<template>
  <div class="page">
    <Waterfall :listData="works" :status="isMyworks" @useGetData="getData()" />
    <WorksGroup @getGid="filterData" v-if="works.length > 0" />
    <div class="empty" v-if="total == 0">
      <i></i>
      <p>目前还没有投稿作品<br />赶快来投稿吧！！！</p>
    </div>
    <!-- <div class="worklist">
      <a class="workitem" href="detail.html">
        <div class="pic-wrap">
          <img
            class="pic"
            src="http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/uploads/cee/188/cee1880f9f1e75fc4444ca90c4c94438.jpg?x-oss-process=image/resize,m_lfit,w_1000,h_1000"
          />
          <div class="vote-num">票数 12</div>
        </div>
        <div class="txt-wrap">
          <div class="user">
            <img
              class="avatar"
              src="http://dy-allimage.oss-cn-hangzhou.aliyuncs.com/avatar/2019/12/09/1575884360-274083.jpg"
            />
            <div class="nickname">昵称昵称</div>
          </div>
          <div class="time">06/11</div>
        </div>
      </a>
    </div> -->
  </div>
</template>

<script>
import Waterfall from "@/components/Waterfall";
import WorksGroup from "@/components/WorksGroup";
export default {
  components: {
    Waterfall,
    WorksGroup,
  },
  props: {
    worksGroup: {
      type: Array,
    },
  },
  data() {
    return {
      works: [],
      matchGroup: [],
      totalPage: 0,
      id: this.$route.params.id,
      // 是否到底部
      end: false,
      gid: "",
      page: 1,
      totalPages: 2,
      // totalPage: 0, // 总页数
      pagesize: 20, // 默认每页20条数据
      total: 1,
      isMyworks: false,
    };
  },
  methods: {
    filterWoks(gid) {
      // console.log(gid);
      if (this.gid != gid) {
        this.$router.push({ query: { group: gid } });
      }
      this.gid = gid;
      this.page = 1;
      this.end = false;
      this.works = [];
      // 重新筛选
      this.getData();
    },
    getList(res) {
      this.works = this.works.concat(res);
      if (this.page < this.totalPages) {
        this.page++;
      } else {
        this.end = true;
      }
    },
    getData() {
      if (this.end) {
        return false;
      }
      this.axios
        .post("/match/works?group=" + this.gid, {
          id: this.id,
          page: this.page,
          pagesize: this.pagesize,
        })
        .then((res) => {
          var data = res.data.data;
          if (this.page <= 1) {
            this.total = data.total;
            this.totalPages = data.totalPages;
          }
          this.getList(data.list);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterData(gid) {
      this.filterWoks(gid);
    },
  },
  mounted() {
    //this.cur = this.$route.query.index;
    this.gid = this.$route.query.group;
    if (this.gid == undefined) {
      this.gid = "";
    }
      var data = {url:window.location.href,id:this.id};
      this.tools.wx_share_init(data);
    // this.filterWoks(this.gid);
  },
};
</script>

<style></style>
